//class
import PadCreator from '../PadCreator';
// utils
import _ from 'lodash';
import { codeGeneretor } from 'app/utils';
// consts
import { TYPE } from 'app/config/prescription_content';
// form
// import { prescriptionTypeInitFormFn } from 'app/components/modals/pad-creator/PrescriptionModal/prescriptionForms/prescriptionTypeForm/utils/prescriptionTypeInitFormFn';
// import { prescriptionDietInitFormFn } from 'app/components/modals/pad-creator/PrescriptionModal/prescriptionForms/prescriptionDietForm/utils/prescriptionDietInitFormFn';
// classes
import { PadPrescriptionType } from './PadPrescriptionType';

/**
 * represents an instance of PadPrescriptionDiet
 * @class PadPrescriptionDiet
 * @extends PadCreator
 */
export default class PadPrescriptionDiet extends PadCreator {
  prepare(padPrescriptionDiets = []) {
    const preparedDiets = padPrescriptionDiets.map(padPrescriptionDiet => {
      const code = codeGeneretor();
      const type = TYPE.SUSTEINED; // mantido

      const { prescriptionTypeForm, dietForm } = padPrescriptionDiet;

      return {
        code,
        type,
        prescriptionTypeForm,
        dietForm
      };
    });

    this._loadedData = _.cloneDeep(preparedDiets);
    this._screenData = _.cloneDeep(preparedDiets);

    return this;
  }

  /**
   * insert a new diet.
   * @param {object} diet - new diet.
   * @returns {object} the state
   */
  add(diet) {
    const screenData = _.cloneDeep(this._screenData);
    const loadedData = _.cloneDeep(this._loadedData);
    const padPrescription = _.cloneDeep(diet);

    const padPrescriptionType = new PadPrescriptionType({ screenData, loadedData });
    const type = padPrescriptionType.getTypeOnAdd(padPrescription);

    padPrescription.type = type;
    padPrescription.code = codeGeneretor();

    this._screenData.push(padPrescription);

    return this;
  }

  /**
   * update a diet.
   * @param {string} code - diet`s code to be edited.
   * @param {object} diet - diet to be edited.
   * @returns {object} return the state
   */
  edit(code, diet = {}) {
    const screenData = _.cloneDeep(this._screenData);
    const loadedData = _.cloneDeep(this._loadedData);
    const padPrescription = _.cloneDeep(diet);

    // find index by code
    const indexScreenToEdit = [...this._screenData].findIndex(item => item.code === code);

    Object.entries(padPrescription).forEach(([key, content]) => {
      this._screenData[indexScreenToEdit][key] = content;
    });

    const padPrescriptionType = new PadPrescriptionType({ screenData, loadedData });
    const type = padPrescriptionType.getTypeOnEdit(padPrescription);

    this._screenData[indexScreenToEdit].type = type;

    return this;
  }

  /**
   * remove a element.
   * @param {string} code - element`s code to remove.
   * @returns {object} return the state
   */
  remove(code) {
    const newScreen = [...this._screenData].filter(currentElement => currentElement.code !== code);

    this._screenData = newScreen;

    return this;
  }

  /**
   * suspend a pad prescription diet.
   * @param {string} code - diet`s code to suspend.
   * @returns {object} return the state
   */
  suspend(code) {
    const newScreen = [...this._screenData].map(currentElement => {
      if (currentElement.code === code) currentElement.type = TYPE.SUSPENDED;

      return {
        ...currentElement
      };
    });

    this._screenData = newScreen;

    return this;
  }

  /**
   * unsuspend a pad prescription diet.
   * @param {string} code - diet`s code to suspend.
   * @returns {object} return the state
   */
  unsuspend(code, prescriptionForm) {
    const screenData = _.cloneDeep(this._screenData);
    const loadedData = _.cloneDeep(this._loadedData);
    const padPrescription = _.cloneDeep(prescriptionForm);

    const padPrescriptionType = new PadPrescriptionType({ screenData, loadedData });
    const type = padPrescriptionType.getTypeOnUnsuspend(padPrescription);

    const newScreen = [...this._screenData].map(currentElement => {
      if (currentElement.code === code) currentElement.type = type;

      return {
        ...currentElement
      };
    });

    this._screenData = newScreen;

    return this;
  }

  replacesAllPrescriptors(prescriptionForm) {
    const { dietForm } = prescriptionForm;
    const { professionalId, responsibleForPrescriptionName } = dietForm;

    const nScreen = [...this._screenData].map(prescription => {
      return {
        ...prescription,
        dietForm: {
          ...prescription.dietForm,
          professionalId: professionalId,
          responsibleForPrescriptionName: responsibleForPrescriptionName
          // formAddOn: {
          //   responsibleForPrescriptionId: professionalId
          // }
        }
      };
    });

    this._screenData = nScreen;
    this._state.data.screen = nScreen;

    return this;
  }
}
